const aboutLinks = {
  title: 'About',
  links: [
    {
      title: 'About us',
      url: '/about-us',
    },
    {
      title: 'Sustainability',
      url: '/sustainability-commitment',
    },
    {
      title: 'International resellers',
      url: '/international-retailers',
    },
    {
      title: 'Careers at Hem',
      url: 'https://careers.hem.com/',
    },
    {
      title: 'Follow us @hem',
      url: 'https://www.instagram.com/hem/',
    },
  ],
};

const supportLinks = {
  title: 'Support',
  links: [
    { title: 'Contact us', url: '/contact-us' },
    { title: 'Frequently asked questions', url: 'https://help.hem.com' },
    { title: 'Care instructions', url: '/care-instructions' },
    { title: 'Submit a claim', url: '/claims' },
  ],
};

const tradeLinks = {
  title: 'Partners and trade',
  links: [
    {
      title: 'Hem Pro',
      url: '/hem-pro',
    },
    {
      title: 'Press downloads',
      url: 'https://drive.google.com/drive/folders/1adPetfOl-lpCTw4ii_o5mwjlhtLkw-c3?usp=share_link',
    },
    {
      title: 'Our designers',
      url: '/designers',
    },
    {
      title: 'Certifications',
      url: '/certifications',
    },
    {
      title: 'Get samples',
      url: '/samples',
    },
  ],
};

const complianceLinks = [
  {
    title: 'Terms and conditions',
    url: '/terms-and-conditions',
  },
  {
    title: 'Privacy policy',
    url: '/privacy-policy',
  },
  {
    title: 'Shipping & return policy',
    url: '/shipping-and-return-policy',
  },
];

export { aboutLinks, supportLinks, tradeLinks, complianceLinks };
